/**
 * Send the guest somewhere that is not this widget.
 *
 * ---------------------------------------------------------------------------
 * WHY THIS IS NOT `window.location.href = url`
 * ---------------------------------------------------------------------------
 *
 * DEFECT (reported): "vraag dit verblijf aan" loaded the enquiry page inside
 * the calculator's own iframe, and the browser answered "refused to connect".
 * The enquiry page declines to be framed, which is right for a page that takes
 * a name and an address.
 *
 * Even where framing were allowed it would be wrong. The guest has finished
 * with the calculator and is filling in a form; doing that in a 600px window
 * inside somebody's tariff page is not the page they asked for. `apps/embed`
 * has always used `target="_top"` on its link for exactly this reason — this
 * is the same move, from script.
 *
 * `window.open(url, '_top')` rather than assigning `top.location`, because the
 * parent is a different origin: the park's site frames the calculator, and a
 * cross-origin frame may navigate the top browsing context only through a user
 * activation. A click is one. Reading `window.top` can itself throw, so it is
 * guarded, and if anything at all goes wrong the frame navigates itself —
 * which is the old behaviour, and a worse outcome than no outcome.
 */
export function leaveTo(url: string, win: Window = window): void {
  try {
    if (win.top && win.top !== win.self) {
      if (win.open(url, '_top')) return;
    }
  } catch {
    // A cross-origin `top` read can throw, and a blocked `open` can too.
  }
  win.location.href = url;
}
